import { startAnimation } from '../vendor/animation';

// NOTE: スプラッシュのクラスの追加/削除を管理する関数
function toggleSplashClasses(action) {
    const htmlElement = document.querySelector('html');

    if (action === 'show') {
        // NOTE: スプラッシュを表示するためのクラスを追加
        htmlElement.classList.add('is-splash-show', 'is-noscroll');
    } else if (action === 'hide') {
        // NOTE: スプラッシュを非表示にするためのクラスを削除
        htmlElement.classList.remove('is-splash-show', 'is-noscroll', 'is-splash-hide');
    } else if (action === 'hide-transition') {
        // NOTE: スプラッシュの遷移(トランジション)を非表示にするためのクラスを操作
        htmlElement.classList.add('is-splash-hide');
        // htmlElement.classList.remove('is-splash-show');
    }
}

// NOTE: スプラッシュを非表示にする関数
function hideSplash() {
    toggleSplashClasses('hide-transition');
    setTimeout(() => {
        toggleSplashClasses('hide');
        startAnimationAfterDelay();
    }, 560);
}

// NOTE: スプラッシュを表示する関数
function showSplash() {
    // window.scrollTo(0, 0);
    setTimeout(() => {
        const y = window.scrollY
        if (y > 0) {
            setTimeout(() => window.scrollTo(0, 0), 200)
        }
    }, 0)
    toggleSplashClasses('show');
}

// NOTE: 指定した遅延後にアニメーションを開始する関数
function startAnimationAfterDelay() {
    startAnimation();
    document.querySelector('html').classList.add('is-animation-ready');
}

showSplash();


document.addEventListener("DOMContentLoaded", function() {
    const progressBar = document.querySelector('#splash-deco-line');
    const resources = document.images;
    const totalResources = resources.length;
    let loadedResources = 0;

    function updateProgress() {
        loadedResources++;
        let progress = (loadedResources / totalResources) * 100;
        progressBar.style.clipPath = `inset(0 ${100 - progress}% 0 0)`;
    }

    // すべての画像に対してロードリスナーを設定
    for (let i = 0; i < totalResources; i++) {
        if (resources[i].complete) {
            updateProgress();
        } else {
            resources[i].addEventListener('load', updateProgress);
            resources[i].addEventListener('error', updateProgress);
        }
    }

    window.addEventListener('load', function() {
        progressBar.style.clipPath = 'inset(0 0% 0 0)';
    });
});


window.addEventListener('load', function () {
    setTimeout(hideSplash, 500);
});
